import TrashIcon from '../iconsComponents/TrashIcon';

export const RemoveRowButtonComponent = ({
  position,
  onRemoveRow,
  iconTitle,
  name
}) => {
  return (
    <div onClick={() => onRemoveRow(position, name)}>
      <TrashIcon title={iconTitle} />
    </div>
  );
};
